import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { CookiesProvider } from 'react-cookie';
import { ProjectProvider } from "./dashboard/components/ProjectContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <HelmetProvider>
            <BrowserRouter>
                <ProjectProvider>
                    <App />
                </ProjectProvider>
            </BrowserRouter>
        </HelmetProvider>
    </CookiesProvider>
);
